/* Holiday owns filtering/placement only. Shared native cards are never rebuilt. */
(() => {
  function init(root) {
    if (root.dataset.holidayReady) return;
    const data = JSON.parse(root.querySelector('[data-holiday-data]').textContent);
    const list = root.querySelector('product-list');
    const cards = new Map([...list.children].map(card => [card.getAttribute('handle'), card]));
    const products = data.filter(p => cards.has(p.handle));
    const filters = [...root.querySelectorAll('[data-holiday-filter]')];
    const categories = filters.filter(e => e.dataset.holidayFilter === 'rider').map(e => e.dataset.value);
    const mq = matchMedia('(max-width:699px)');
    const budgets = {'under-75':[0,7500],'75-150':[7500,15000],'150-plus':[15000,Infinity]};
    let expanded = false, letter = false;
    const clean = values => ({rider:categories.includes(values.rider)?values.rider:'',budget:root.dataset.currency==='USD'&&Object.hasOwn(budgets,values.budget)?values.budget:'',gender:['men','women'].includes(values.gender)?values.gender:'all',sort:['price-asc','price-desc'].includes(values.sort)?values.sort:'featured'});
    const read = () => clean(Object.fromEntries(new URLSearchParams(location.search)));
    let state = read();
    const control = el => el.matches('button')?el:el.querySelector('button');
    const matches = (p,s) => (!s.rider||p.categories[s.rider]>0)&&(!s.budget||(p.price>=budgets[s.budget][0]&&p.price<budgets[s.budget][1]))&&(s.gender==='all'||p.gender==='unisex'||p.gender===s.gender);
    const save = () => {
      const url = new URL(location.href);
      for (const [key,value] of Object.entries(state)) {
        url.searchParams.delete(key);
        if(value&&!['all','featured'].includes(value))url.searchParams.set(key,value);
      }
      history.pushState(null,'',url);
    };
    function render() {
      const selected = products.filter(p=>matches(p,state)).sort((a,b)=>state.sort==='price-asc'?a.price-b.price||a.rank-b.rank:state.sort==='price-desc'?b.price-a.price||a.rank-b.rank:state.rider?a.categories[state.rider]-b.categories[state.rider]||a.rank-b.rank:a.rank-b.rank);
      const limit = mq.matches?12:16;
      const visible = expanded?selected:selected.slice(0,limit);
      // Move existing root cards so keyboard/reading order matches visible sort order.
      // moveBefore preserves connected state where supported; insertBefore retains nodes
      // and lets the theme's normal custom-element lifecycle reconnect on older browsers.
      const selectedHandles=new Set(selected.map(p=>p.handle));
      const ordered=[...selected,...products.filter(p=>!selectedHandles.has(p.handle))];
      ordered.forEach((p,i)=>{
        const card=cards.get(p.handle),before=list.children[i]??null;
        if(before===card)return;
        if(typeof list.moveBefore==='function')list.moveBefore(card,before);
        else list.insertBefore(card,before);
      });
      // Root-card visibility only: no innerHTML, swatch, price, badge or quick-buy changes.
      for (const card of cards.values()) card.hidden = true;
      visible.forEach(p=>{cards.get(p.handle).hidden=false;});
      for (const filter of filters) {
        const active = state[filter.dataset.holidayFilter]===filter.dataset.value;
        filter.dataset.active=String(active);control(filter).setAttribute('aria-pressed',String(active));
      }
      root.querySelector('[data-holiday-count]').textContent=String(selected.length);
      root.querySelector('[name=holiday-sort]').value=state.sort;
      root.querySelector('[data-holiday-empty]').hidden=selected.length>0;
      root.querySelector('[data-holiday-action=more]').hidden=expanded||selected.length<=limit;
      root.querySelector('[data-holiday-action=less]').hidden=!expanded||selected.length<=limit;
      const status=root.querySelector('[data-holiday-page-status]');
      status.textContent=status.dataset.pattern.replace('{shown}',String(visible.length)).replace('{total}',String(selected.length));
      const filtered=Boolean(state.rider||state.budget||state.gender!=='all');
      // Exactly one visible H1 in either introductory or condensed presentation.
      root.querySelector('[data-holiday-letter]').hidden=filtered&&!letter;
      root.querySelector('[data-holiday-condensed]').hidden=!filtered||letter;
      root.querySelector('[data-holiday-action=reset]').hidden=!filtered&&state.sort==='featured';
    }
    root.addEventListener('click',event=>{
      const filter=event.target.closest('[data-holiday-filter]');
      if(filter&&root.contains(filter)){
        const {holidayFilter:key,value}=filter.dataset;
        state[key]=state[key]===value&&key!=='gender'?'':value;expanded=false;letter=false;save();render();
        // A selected tile stays in place and retains keyboard focus.
        return;
      }
      const action=event.target.closest('[data-holiday-action]')?.dataset.holidayAction;
      if(!action)return;
      if(action==='reset'){state=clean({});expanded=false;letter=false;save();}
      if(action==='letter')letter=true;
      if(action==='more')expanded=true;
      if(action==='less')expanded=false;
      render();
      if(action==='more'||action==='less'){
        const other=root.querySelector(`[data-holiday-action=${expanded?'less':'more'}] button`);
        if(other&&!other.parentElement.hidden)other.focus({preventScroll:true});
      }
      if(action==='reset')control(filters.find(e=>e.dataset.holidayFilter==='gender'&&e.dataset.value==='all')).focus({preventScroll:true});
      if(action==='letter')root.querySelector('[data-holiday-letter] a').focus({preventScroll:true});
    });
    root.querySelector('[name=holiday-sort]').addEventListener('change',event=>{state.sort=event.target.value;expanded=false;save();render();});
    const abort=new AbortController();
    window.addEventListener('popstate',()=>{state=read();expanded=false;letter=false;render();},{signal:abort.signal});
    mq.addEventListener('change',render,{signal:abort.signal});
    document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(root))abort.abort();},{signal:abort.signal});
    root.querySelectorAll('[data-holiday-controls]').forEach(el=>{el.hidden=false;});
    root.dataset.holidayReady='true';render();
  }
  function start(scope){scope.querySelectorAll('[data-holiday-guide]').forEach(init);}
  start(document);
  if(!window.volerHolidaySectionListener){document.addEventListener('shopify:section:load',event=>start(event.target));window.volerHolidaySectionListener=true;}
})();
